import React, { useEffect, useState } from "react";
import Layout from "../../Layout/Layout";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Col, Row, Form } from "react-bootstrap";
import noimage from "../../assets/img/noimage.png";
import { useDispatch } from "react-redux";
import { Subcategory } from "../../actions/users";
import { ImgEmpty, isEmpty } from "../../actions/commonFunction";
import { toast } from "react-toastify";
import config from "../../lib/config";

const initialFormValue = {
  name: "",
};

const CategoryView = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [formValue, setFormValue] = useState(initialFormValue);
  const [validateError, setValidateError] = useState({});
  const [category, setCategory] = useState({});
  const [number, setNumber] = useState([0]);
  const [subcategory, setSubCategory] = useState({});

  const onChange = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    setCategory({ ...category, ...{ name: value } });
  };

  const { name } = formValue;

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    var error = Validate();
    if (isEmpty(error)) {
      var arr = [];
      number.map((val) => {
        arr.push(subcategory[val]);
      });
      var send = category;
      send.subcategory = JSON.stringify(arr);
      send.action = "edit";
      var resp = await Subcategory(send);
      if (resp?.data?.success) {
        toast.success("Updated Successfully", 1000);
        setTimeout(() => {
          navigate("/categorylist");
        }, 1000);
      } else {
        toast.error("Category not updated", 1000);
      }
    } else {
      setValidateError(error);
    }
  };

  useEffect(() => {
    GetCategory();
  }, []);

  var GetCategory = async () => {
    var resp = await Subcategory({ _id: id, action: "get" });

    setCategory(resp.data.list);
    var sub = {};
    resp.data.list.subcategory.map((val, ind) => {
      sub[ind] = val;
    });
    setSubCategory(sub);
    setNumber(Object.keys(sub));
  };

  var onsubChange = (e) => {
    const { id, value } = e.target;
    setSubCategory({ ...subcategory, ...{ [id]: value } });
  };

  var Validate = () => {
    var error = {};
    if (isEmpty(category.name)) {
      error.name = "Category Name Required";
    }
    number.map((val) => {
      if (isEmpty(subcategory[val])) {
        error["subcategor" + val] = "Sub-Category Required";
      }
    });
    return error;
  };

  const FileChange = (e) => {
    var file = e.target.files[0];
    var fileName = file.name;
    var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
    var validExtensions = ["png", "webp", "PNG", "jpg", "JPEG", "jpeg", "JPG"]; //array of valid extensions
    if (validExtensions.findIndex((check) => check == fileNameExt) === -1) {
      toast.error(
        "Only these file types are accepted : " + validExtensions,
        1000
      );
      return false;
    }
    setCategory({ ...category, ...{ image: file } });
  };

  const deleteSubCategory = (ind) => {
    let data = subcategory;
    delete data[ind];
    Object.values(data).map((val, ind) => {
      data[ind] = val;
    });
    setSubCategory({ ...data });
    let num = number;
    num.splice(num.indexOf(ind), 1);
    setNumber([...num]);
  };

  return (
    <Layout>
      <div className="categoryview">
        <Link to="/categorylist" className="btn sitebtn mb-4">
          Back
        </Link>
        <h1 className="pagehead">Edit Category</h1>
        <div className="cardbox">
          <Form>
            <Row>
              <Col xs={12} sm={12} md={6} className="mb-3">
                <Form.Group className="d-flex align-items-end gap-4">
                  <div className="flex-grow-1">
                    <Form.Label>Category name</Form.Label>
                    <Form.Control
                      type="text"
                      onChange={onChange}
                      id="name"
                      value={category.name || ""}
                      placeholder="Category name"
                    />
                    {validateError.name && (
                      <span className="text-danger">{validateError.name}</span>
                    )}
                  </div>
                  <button
                    type="button"
                    className="btn sitebtn py-2 px-3"
                    onClick={() => {
                      setNumber([...number, ...[number.length]]);
                    }}
                  >
                    Add
                  </button>
                </Form.Group>
                {number?.length > 0 ? (
                  number?.map((val, ind) => {
                    return (
                      <>
                        <Col xs={12} sm={12} md={6} className="mb-3">
                          <Form.Group className="d-flex align-items-end gap-4">
                            <div className="flex-grow-1">
                              <Form.Label>Sub-Category name</Form.Label>
                              <Form.Control
                                type="text"
                                onChange={onsubChange}
                                id={String(ind)}
                                value={subcategory[ind] || ""}
                              />
                            </div>
                            <button
                              type="button"
                              className="btn sitebtn py-2 px-3"
                              onClick={() => {
                                deleteSubCategory(ind);
                              }}
                            >
                              Delete
                            </button>
                          </Form.Group>
                        </Col>
                        {validateError["subcategor" + ind] && (
                          <span className="text-danger">
                            {validateError["subcategor" + ind]}
                          </span>
                        )}
                      </>
                    );
                  })
                ) : (
                  <></>
                )}
              </Col>

              {/* {
                                number?.length > 0 ?
                                    (number?.map((val, ind) => {
                                        return (
                                            <>
                                                <Col xs={12} sm={12} md={6} className="mb-3">
                                                    <Form.Group>
                                                        <Form.Label>Sub-Category name</Form.Label>
                                                        <Form.Control type="text" onChange={onsubChange} id={String(ind)} value={subcategory[ind] || ''} />
                                                    </Form.Group>
                                                </Col>
                                                {
                                                    validateError['subcategor' + ind] && <span className="text-danger">{validateError['subcategor' + ind]}</span>
                                                }
                                            </>
                                        )
                                    }
                                    ))
                                    :
                                    <></>
                            } */}


              <Col xs={12} sm={12} md={6} className="mb-3">
                <Form.Group>
                  <Form.Label>
                    Category Profile :{" "}
                    <small className="t-grey pl-3">
                      JPG, JPEG, PNG, WEBP. Max 30 megabytes
                    </small>
                  </Form.Label>
                  <Form.Control
                    type="file"
                    id="image"
                    onChange={(e) => FileChange(e)}
                  />
                </Form.Group>

              </Col>

              <Col xs={12} sm={12} md={6} className="mb-3">
                <Form.Group>

                  <Form.Label>Profile Preview</Form.Label>
                  <div className="uploadimgbox">
                    <img
                      src={
                        ImgEmpty(category?.image)
                          ? noimage
                          : typeof category?.image == "string"
                          ? `${config.Back_Url}/category/${category?._id}/${category.image}`
                          : URL.createObjectURL(category.image)
                      }
                      alt=""
                      className="img-fluid previewimg"
                    />
                  </div>
                </Form.Group>
              </Col>

              {/* <Col xs={12} sm={12} md={6} className="mb-3">
                                <Form.Group>
                                    <Form.Label>Profile Preview</Form.Label>
                                    <div className="uploadimgbox">
                                        <img
                                            src={
                                                ImgEmpty(category?.image)
                                                ?
                                                noimage
                                                :
                                                (
                                                    typeof(category?.image) =='string'
                                                    ?
                                                    `${config.Back_Url}/category/${category?._id}/${category.image}`
                                                    :
                                                    URL.createObjectURL(category.image)
                                                )
                                            }
                                            alt="" 
                                            className="img-fluid previewimg"
                                        />
                                    </div>
                                </Form.Group>
                            </Col> */}

            </Row>
            <button
              type="button"
              className="btn sitebtn py-2 px-3"
              onClick={handleFormSubmit}
            >
              Edit
            </button>
          </Form>
        </div>
      </div>
    </Layout>
  );
};

export default CategoryView;

